import { createContext } from "react";
import { RCRASubmissionSaveAction } from "../../../services/MyEmoryRCRASubmissionService";

export type RCRAFormContextProps = {
  action: RCRASubmissionSaveAction;
};
export const RCRAFormContext = createContext<RCRAFormContextProps>({
  action: RCRASubmissionSaveAction.CreateNewRequest,
});
